import React from "react";

import Lamina16fondo from "../images/lamina16fondo.png";
import Lamina16text from "../images/lamina16text.png";
import Lamina16text2 from "../images/lamina16text2.png";
import Lamina16dialogo from "../images/lamina16dialogo.png";
import Lamina16actividad from "../images/lamina16actividad.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";
import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  blue: {
    color: theme.palette.blue.main,
    borderColor: theme.palette.blue.main,
  },
  root: {
    textAlign: "center",
    marginTop: -280,
    "& li": {
      textAlign: "left",
    },
    [theme.breakpoints.down("md")]: {
      marginTop: -120,
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
  root2: {
    textAlign: "center",
    marginTop: -180,
    [theme.breakpoints.down("md")]: {
      marginTop: -80,
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
}));

const Lamina16 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 16: Valores para la convivencia en familia"
        meta={[
          {
            property: "og:title",
            content: "Lámina 16: Valores para la convivencia en familia",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "Para vivir armoniosamente en familia, es necesario que existan normas en casa y que todos las respetemos, practicando valores en el interior de nuestro hogar.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="16" color="blue" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Title title="Valores para la convivencia en familia" color="blue" />
        <p>
          Para vivir armoniosamente en familia, es necesario que existan normas
          en casa y que todos las respetemos, practicando valores en el interior
          de nuestro hogar. El diálogo respetuoso y la tolerancia son muy
          importantes porque nos permiten conocer los puntos de vista de todos y
          alcanzar acuerdos con empatía.
        </p>
        <Actividad color="blue" />
        <p>
          <strong>Observa la situación y luego responde las preguntas.</strong>
        </p>
        <img src={Lamina16fondo} alt="Actividad" />
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="flex-end"
          justify="center"
        >
          <Grid item lg={8} md={8} sm={6} xs={12}>
            <ul>
              <li>¿Por qué discuten Brayan y María?</li>
              <li>¿Qué podrían hacer para resolver este conflicto?</li>
              <li>¿Suceden en tu hogar situaciones parecidas?</li>
              <li>¿Cómo las resuelven?</li>
            </ul>
          </Grid>
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <img src={Lamina16text} alt="Actividad" />
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <TitleSmall title="EL VALOR DE LA HONESTIDAD" color="blue" />
        <br></br>
        <Actividad color="blue" />
        <p>
          <strong>Observa la imagen y lee el siguiente diálogo:</strong>
        </p>
        <img src={Lamina16dialogo} alt="Actividad" />
        <Grid
          container
          className={classes.root2}
          spacing={1}
          alignItems="flex-end"
          justify="center"
        >
          <Grid item lg={8} md={8} sm={6} xs={12}></Grid>
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <img src={Lamina16text2} alt="Actividad" />
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="blue" />
        <p>
          <strong>
            Busca en el pupiletras las siguientes palabras clave para la
            convivencia:
          </strong>
        </p>
        <img src={Lamina16actividad} alt="Actividad" />
        <p>
          Si no conoces el significado de algunas de estas palabras, consulta
          con un familiar y búsquenla en el diccionario.
        </p>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-16.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.blue }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 16: Valores para la convivencia en familia'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="Normas de convivencia"
        anteriorEnlace="/lamina-1-15"
        siguiente="Emergencias, solidaridad y prevención"
        siguienteEnlace="/lamina-1-17"
      />
    </>
  );
};

export default Lamina16;
